import React from 'react';
import PropTypes from 'prop-types';

function HighlightedText({text, highlightedText, ...rest}) {
  return (
    <span {...rest}>
      {
        text.split(new RegExp(`(${highlightedText})`, 'gi'))
          .map((part, i) => <span key={i} style={part.toLowerCase() === highlightedText.toLowerCase() ? { fontWeight: 'bolder' } : {}}>{part}</span>)
      }
    </span>
  );
}

HighlightedText.propTypes = {
  text: PropTypes.string.isRequired,
  highlightedText: PropTypes.string.isRequired
};

export default HighlightedText;